import { ensureDefined, getTokensInTemplate } from '@avantia/client-and-server-utilities';
import { getAnswersFromAnswerMap } from '../../../engineClient/tools/clientAndServerUtilities';
import { formatDate } from '../../../engineClient/tools/dateTools';
import { getQuestionIdFor } from '../../../engineClient/tools/questionIds';
import { HpClientAnswerMap, HpClientQuestionMap } from '../../../engineClient/types';

const dateFormat = 'DD MMMM YYYY';

export interface ResolveTokensInQuestionTextProps {
  questionText: string;
  answers: HpClientAnswerMap;
  questions: HpClientQuestionMap;
  productId: string;
}

export function resolveTokensInQuestionText(props: ResolveTokensInQuestionTextProps): string {
  const { questionText, answers, questions, productId } = props;

  const tokens = getTokensInTemplate(questionText);

  if (tokens.length === 0) {
    return questionText;
  }

  const resolvedTokens = getAnswersFromAnswerMap({ answers, keys: tokens, productId });

  let result = questionText;
  for (const token of tokens) {
    const questionId = getQuestionIdFor(productId, token);
    const question = ensureDefined(questions[questionId], `questions['${questionId}']`);
    const { dataType } = question;
    const value = resolvedTokens[token] as string;
    result = result.replace(`{{${token}}}`, formatTokenValue(value, dataType));
  }

  return result;
}

function formatTokenValue(value: string, dataType: string): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  if (dataType === 'date') {
    return formatDate(value, dateFormat);
  }

  return value;
}
